import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import PathSection from "@/components/landing/PathSection";
import ThreeSteps from "@/components/landing/ThreeSteps";
import PropertyAdvisor from "@/components/landing/PropertyAdvisor";
import AgentsSection from "@/components/landing/AgentsSection";
import FAQ from "@/components/landing/FAQ";
import FinalCTA from "@/components/landing/FinalCTA";
import Footer from "@/components/landing/Footer";

export default function LandingPage() {
  return (
    <main data-testid="landing-page" className="bg-white text-[#0A0A0A]">
      <Navbar />
      <Hero />
      <PathSection />
      <ThreeSteps />
      <PropertyAdvisor />
      <AgentsSection />
      <FAQ />
      <FinalCTA />
      <Footer />
    </main>
  );
}
